/** Local cache for e-sign profile + unlock secrets (hash only). */

const KEY = "nevisign-esign-local";

export type ESignLocalCache = {
  userId: string;
  identityVerified: boolean;
  hasRootCertificate: boolean;
  onboardingComplete: boolean;
  fingerprintEnabled: boolean;
  patternEnabled: boolean;
  unlockPasswordHash: string | null;
  patternHash: string | null;
  signatureSvg: string | null;
  province: string | null;
  city: string | null;
  address: string | null;
  bannerDismissedAt?: string | null;
};

export function loadEsignLocal(userId: string): ESignLocalCache | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw) as ESignLocalCache;
    if (data.userId !== userId) return null;
    return data;
  } catch {
    return null;
  }
}

export function saveEsignLocal(cache: ESignLocalCache): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(cache));
  } catch {
    /* quota / private mode */
  }
}

export function clearEsignLocal(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function canCertSignFromLocal(userId: string | null | undefined): boolean {
  if (!userId) return false;
  const c = loadEsignLocal(userId);
  return Boolean(c?.identityVerified || c?.hasRootCertificate);
}
